module.exports = __webpack_public_path__ + "img/about2.9ad23410.png";